import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverDirective } from '@shared/components/popover/popover.directive';

@Component({
  selector: 'cx-cut-off-time',
  imports: [CommonModule, PopoverDirective, TranslateModule],
  templateUrl: './cut-off-time.component.html',
  styleUrl: './cut-off-time.component.scss',
})
export class ProductCardCutOffComponent {
  @Input({ required: true }) time!: string;
}
